import PropTypes from 'prop-types';

import stylesCommon from '../../Question.scss';

export const Option = ({ displayName }) => (
  <em className={`${stylesCommon.OptionsList__option} sessioncamhidetext`}>{displayName}</em>
);

Option.propTypes = {
  displayName: PropTypes.string.isRequired,
};
